var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "width": "670px",
      "title": "Upload Picture",
      "close-on-click-modal": false,
      "visible": _vm.visible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "upload-container",
    class: {
      preview: _vm.preview
    }
  }, [_c('div', {
    staticClass: "upload-button"
  }, [_c('div', [_c('svg-icon', {
    staticClass: "upload-icon",
    attrs: {
      "name": "upload"
    }
  }), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("Upload picture, support jpg, png")])], 1)]), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.uploading,
      expression: "uploading"
    }],
    staticClass: "img-preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.previewImgUrl
    }
  })]), _c('input', {
    ref: "fileupload",
    staticStyle: {
      "opacity": "0",
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "left": "0",
      "top": "0"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _c('div', {
    staticClass: "pb20"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }